import { useDiagramButton } from '../insertButtonHooks/useDiagramButton'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertDiagramButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const addDiagram = useDiagramButton(view)
  const onClick = () => {
    addDiagram()
    dropdownStore?.hardClose()
  }

  return <SingleMenuDropdownItem icon={<ToolbarIcon name={IconName.Data} />} label="Diagram" handleClick={onClick} />
}
